import { getHandle } from 'utils/router/utils/getHandle'

export const ShareFlowRoutes = [
  {
    path: 'importSharedFlow/:share_hash',
    handle: getHandle('flow'),
    lazy: () => import('./importSharedFlow.page'),
  },
] as const
